import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  Heading,
  Icon,
  Button,
  Loading,
  Text
} from 'components/common/Elements/Elements';

import classes from './ModalWindowNew.module.scss';

const ModalWindowNew = ({
  isOpen = false,
  headerText,
  setIsOpen,
  children,
  handleOk,
  textCancel,
  textOk,
  loader
}) => {
  const modalRef = useRef();

  const getFirstLast = () => {
    const focusableModalElements = modalRef.current.querySelectorAll(
      'a[href], button, textarea, input, select'
    );
    const focusableElements = Object.values(focusableModalElements).filter(
      elem => elem.disabled !== true
    );
    return {
      firstElement: focusableElements[0],
      lastElement: focusableElements[focusableElements.length - 1]
    };
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', escFunction);
    } else {
      document.removeEventListener('keydown', escFunction);
    }
    return () => {
      document.removeEventListener('keydown', escFunction);
    };
    // eslint-disable-next-line
  }, [isOpen]);

  const escFunction = e => {
    if (!loader) {
      if (e.code === 'Escape') setIsOpen(false);
      if (e.shiftKey && e.keyCode === 9) {
        const elements = getFirstLast();
        if (document.activeElement === elements.firstElement) {
          elements.lastElement.focus();
          e.preventDefault();
        }
      }
      if (!e.shiftKey && e.keyCode === 9) {
        const elements = getFirstLast();
        if (document.activeElement === elements.lastElement) {
          elements.firstElement.focus();
          e.preventDefault();
        }
      }
    }
  };

  const handleBg = e => {
    if (!loader) {
      if (e.target.id === 'modal') {
        setIsOpen(false);
      }
    }
  };

  if (isOpen) {
    return (
      <div
        className={classes.modalBg}
        id="modal"
        onClick={handleBg}
        role="dialog"
        aria-modal="true"
      >
        <div ref={modalRef} className={classes.modalBody}>
          <Button
            className={classes.clear}
            onClick={!loader ? () => setIsOpen(false) : () => {}}
            title="close modal"
          >
            <Icon icon="close" className={classes.icon} size="20px" />
          </Button>
          <Heading className={classes.title}>{headerText}</Heading>
          <div className={classes.bodyModal}>{children}</div>
          <div className={classes.buttonsWrap}>
            <Button
              className={classes.buttonCancel}
              onClick={() => setIsOpen(false)}
              disabled={loader}
            >
              {textCancel}
            </Button>
            <Button
              className={classes.buttonOk}
              onClick={handleOk}
              disabled={loader}
            >
              <Text
                className={cn(
                  classes.buttonOk_text,
                  loader && classes.buttonOk_text__hide
                )}
              >
                {textOk}
              </Text>
              {loader && <Loading size={'small'} className={classes.loader} />}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ModalWindowNew;

ModalWindowNew.propTypes = {
  isOpen: PropTypes.bool,
  headerText: PropTypes.string,
  setIsOpen: PropTypes.func.isRequired,
  children: PropTypes.object,
  handleOk: PropTypes.func.isRequired,
  textCancel: PropTypes.string.isRequired,
  textOk: PropTypes.string.isRequired,
  loader: PropTypes.bool
};
